// Is this a phone-sized screen? One answer for every player surface (mobile.css draws the same line).
//
// ⚠ PLAYERS ONLY, BY WIDTH: the phone layout — bottom tab bar, bottom-sheet pickers, no rail — kicks in under 720px, the
// width below which the players' side panel already covered the map. A tablet keeps the rail it has; the GM's workspace
// is a desktop app and never asks.
import { useEffect, useState } from "react";

export const PHONE_QUERY = "(max-width: 720px)";

export function isPhoneNow(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(PHONE_QUERY).matches;
}

/** True on a phone-sized screen; follows a rotation or a resize. */
export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(isPhoneNow);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(PHONE_QUERY);
    const on = () => setPhone(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return phone;
}
